<div class="modal-header justify-content-between d-flex pt-4">
  <h1 class="modal-title">{{ title() }}</h1>
  <span (click)="closeDialog()" role="button" class="ms-auto cursor-pointer">
    <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
  </span>
</div>
<div class="modal-body">
  <lib-signature-pad
    [options]="options()"
    [width]="width()"
    [height]="height()"
    (signatureSaved)="onSignatureSaved($event)"
    (signatureCleared)="onSignatureCleared()"
    #signaturePad
  ></lib-signature-pad>
</div>
<div class="modal-footer d-flex justify-content-between">
  <button type="button" class="btn btn-outline-secondary" (click)="onClear()">Clear</button>
  <div class="d-flex gap-2">
    @if (showDownloadButton()) {
      <button type="button" class="btn btn-secondary" (click)="downloadSignature()">Download</button>
    }
    <button type="button" class="btn btn-primary" (click)="onSave()" [disabled]="signaturePad.isEmptySignature()">
      Save Signature
    </button>
  </div>
</div>
